export default "__VITE_ASSET__DbR6tQBZ__"